<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field
            :label="getCompanyLabels.products + ' Name'"
            v-model="name"
          ></v-text-field>
        </v-col>
        <v-col :cols="12">
          <v-text-field
            :label="getCompanyLabels.products + ' Code'"
            v-model="code"
          ></v-text-field>
        </v-col>
        <v-col :cols="12">
          <ForeignKeyField
            foreignColumn="category_id"
            :foreignTablesArray="['items_categories']"
            :foreignKeysArray="['category_id']"
            :foreignFieldValue="productCategory"
            :branchID="null"
            @field-selected="setCategory"
          ></ForeignKeyField>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col :cols="4"
          ><v-text-field
            :label="isMobile ? getCompanyLabels.products + ' Cost' : 'Cost'"
            v-model="cost"
          ></v-text-field
        ></v-col>
        <v-col :cols="4"
          ><v-text-field
            :label="
              isMobile ? getCompanyLabels.products + 'Selling Price' : 'Price'
            "
            v-model="price"
          ></v-text-field
        ></v-col>
        <v-col :cols="4">
          <v-autocomplete
            v-model="list"
            :items="['Yes', 'No']"
            dense
            color="teal"
            filled
            label="List On Store"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-autocomplete
          class="mb-4"
          @change="takeActionAfterSupplierSelected"
          v-model="selectedSupplier"
          :items="suppliers"
          dense
          color="teal"
          filled
          label="Select Supplier"
        ></v-autocomplete>
        <div v-if="showCreateSupplier">
          <CreateSupplier
            @supplier-created="getNewlyCreatedSupplier"
          ></CreateSupplier>
        </div>
        <DatePickerWithMenu
          @date-selected="getSelectedDate"
          class="mt-n6 ml-n4 mr-2"
        ></DatePickerWithMenu>
        <div>
          <v-text-field
            label="Quantity Received"
            v-model="quantity"
          ></v-text-field>
        </div>

        <div>
          <v-btn
            class="mt-2"
            dark
            rounded
            color="teal"
            small
            @click="createProductAndRecordReceivingsToReceivingsTable()"
            ><v-icon left>mdi-plus</v-icon>Create Product</v-btn
          >
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import productsAndServicesJs from "@/plugins/productsAndServices";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import CreateSupplier from "./CreateSupplier.vue";

export default {
  components: {
    ForeignKeyField,
    DatePickerWithMenu,
    CreateSupplier,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
  },
  async mounted() {
    await this.getAllSuppliers();
  },
  data: () => ({
    showCreateSupplier: false,
    name: null,
    cost: 0,
    price: 0,
    code: null,
    categoryID: null,
    productCategory: null,
    list: "No",
    newlyCreatedSupplier: null,
    suppliers: [],
    selectedSupplier: null,
    supplierID: null,
    quantity: 1,
    date: new Date().toISOString().substring(0, 10),
  }),
  methods: {
    setCategory(vals) {
      this.categoryID = vals[0];
      this.productCategory = vals[1];
    },
    stripCommasFromMoney(amount) {
      return helpersJs.stripCommasFromMoney(amount);
    },
    async getAllSuppliers() {
      const suppliers = await productsAndServicesJs.getAllSuppliers();

      if (suppliers.length > 0) {
        this.suppliers = [];
        suppliers.forEach((supplier) => {
          this.suppliers.push({ text: supplier.name, value: supplier });
        });
      }
    },
    getNewlyCreatedSupplier(newlyCreatedSupplier) {
      this.suppliers.unshift({
        text: newlyCreatedSupplier.name,
        value: newlyCreatedSupplier,
      });
      this.selectedSupplier = newlyCreatedSupplier;
      this.showCreateSupplier = false;
      this.getSelectedSupplier(newlyCreatedSupplier);
    },
    getSelectedSupplier(selectedSupplier) {
      this.supplierID = selectedSupplier.id;
      this.$emit("supplier-selected", selectedSupplier);
    },
    takeActionAfterSupplierSelected(selectedSupplier) {
      if (
        selectedSupplier &&
        selectedSupplier.name &&
        selectedSupplier.name.includes("Add New")
      ) {
        this.showCreateSupplier = true;
      } else {
        this.showCreateSupplier = false;
        this.getSelectedSupplier(selectedSupplier);
      }
    },
    getSelectedDate(selectedDate) {
      this.date = selectedDate;
    },
    async createProductAndRecordReceivingsToReceivingsTable() {
      if (
        this.name &&
        this.price &&
        this.categoryID &&
        this.supplierID &&
        this.quantity
      ) {
        this.$store.commit("setLoader", true);
        this.cost = this.stripCommasFromMoney(this.cost);
        this.price = this.stripCommasFromMoney(this.price);

        const product =
          await productsAndServicesJs.createProductAndAddToReceivings(
            this.name,
            this.cost,
            this.price,
            this.categoryID,
            this.code,
            this.list,
            this.supplierID,
            this.date,
            this.quantity
          );

        this.$emit("product-created", product);
        this.$store.commit("setLoader", false);
        this.$toast.success("Product Created Successfully!", {
          duration: 3000,
        });
      } else {
        alert(
          "Fill in at least Name, Cost, Price, Category, Supplier And Quantity!"
        );
      }
    },
  },
};
</script>
